<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.isAdmin();
  },
  methods: {
    // 鉴权数据面板
    async isAdmin() {
      let data = await this.$get("/statistics/isAdmin");
      localStorage.setItem("DataPanelAuthentication", data.data);
    }
  }
};
</script>

<style>
#app {
  text-align: center;
  background: #fafafa;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue